import { FC } from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import { useFormContext } from './form-provider';

type FormConditionalValueProps = {
  id: string;
  when(value: any): boolean;
  children: JSX.Element | JSX.Element[];
  animate?: boolean;
};

export const FormConditionalValue: FC<FormConditionalValueProps> = ({
  id,
  when,
  children,
  animate = false,
}) => {
  const { store } = useFormContext();
  const state = store.useFieldValue(id);
  const show = when(state);

  if (!animate) return show ? <>{children}</> : null;

  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          transition={{ duration: 0.15 }}
          animate={{ opacity: 1, scale: 1 }}
          initial={{ opacity: 0, scale: 0.95 }}
          exit={{
            opacity: 0,
            scale: 0.9,
            height: 0,
            overflow: 'hidden',
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
